import SearchIcon from '@mui/icons-material/Search'
import { IconButton, Toolbar, Tooltip, styled, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { IconBackspace, IconCirclePlus, IconFilter } from '@tabler/icons-react'
import { UsersFilterDrawer } from './UsersFilterDrawer'
import { Search, StyledInputBase } from '../../../../../../config'
import { useDispatch, useSelector } from '../../../../../../store/store'
import { dialogToggle } from '../../../../../../store/slices/dialog'
import { setInternalUsersFilterQuerySearch } from '../../../../../../store/slices/filters/filters'

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const RemoveSearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const UsersEnhancedTableToolbar = () => {
  const { internalUsersFilterQuerySearch } = useSelector((state) => state.filters)
  const [searchValue, setSearchValue] = useState(internalUsersFilterQuerySearch || '')
  const [debouncedSearchValue] = useDebounce(searchValue, 300)

  const [drawerOpen, setDrawerOpen] = useState(false)
  const handleOpen = () => dispatch(dialogToggle(true))

  const dispatch = useDispatch()
  const theme = useTheme()

  useEffect(() => {
    dispatch(setInternalUsersFilterQuerySearch(debouncedSearchValue))
  }, [debouncedSearchValue, dispatch])

  return (
    <>
      <Toolbar>
        <Search sx={{ flex: '1 1 100%', display: 'flex', alignContent: 'baseline' }}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
            autoFocus
          />
          {internalUsersFilterQuerySearch && (
            <RemoveSearchIconWrapper
              onClick={() => dispatch(setInternalUsersFilterQuerySearch(''))}
            >
              <IconBackspace size="24px" className="removeIcon" />
            </RemoveSearchIconWrapper>
          )}
        </Search>
        <Tooltip onClick={() => setDrawerOpen(!drawerOpen)} title="Filter list">
          <IconButton>
            <IconFilter size="20px" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Add new" onClick={handleOpen}>
          <IconButton>
            <IconCirclePlus
              stroke="none"
              size="35px"
              fill={theme.palette.primary.main}
              color={theme.palette.primary.light}
            />
          </IconButton>
        </Tooltip>

        <UsersFilterDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      </Toolbar>
    </>
  )
}
